module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Voltage_16"],"polygon":[{"$":{"points":"5.42 0 10.24 0 6.99 5.94 12.43 3.77 6.11 16 8.47 8.03 3.65 10.06 5.42 0","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Voltage_16.svg
// module id = t8o5
// module chunks = 1